import script from "./SimPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./SimPanel.vue?vue&type=script&setup=true&lang=js"

import "./SimPanel.vue?vue&type=style&index=0&id=06f03c3c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06f03c3c"]])

export default __exports__